import React from "react";
import { dataService } from "tools/dataService/dataService"
import { platformStateTag } from "tools/commonFunctions";
import { trackPromise } from "react-promise-tracker";
import ServiceApp from "./ServiceApp"
import GenericModal from "components/Modal/GenericModal";
import { withRouter } from "react-router-dom";

import {
  Col,
  Row,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Table,
  UncontrolledTooltip
} from "reactstrap";

class PlatformService extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      serviceId: this.props.serviceId,
      serviceName: this.props.serviceName,
      serviceImage: this.props.serviceImage,
      kubernetesState: this.props.kubernetesState,
      kubernetesStateLevel: this.props.kubernetesStateLevel,
      kubeAccessStatus: this.props.kubeAccessStatus,
      kubeConnectStatus: this.props.kubeConnectStatus,
      apps: [],
      lockedAppId: null,
      lockedAppName: "",
      blockEditModalOpen: false,
      leavePageModalOpen: false,
      pendingNavLocation: null
    }
  }

  componentDidMount() {
    let activePlatformDataObj = JSON.parse(localStorage.getItem('ActivePlatformData'));
    if (this.props.history && typeof this.props.history.block === "function") {
      this.unblockHistory = this.props.history.block((location) => {
        if (!this.state.lockedAppId) return true;
        this.setState({
          leavePageModalOpen: true,
          pendingNavLocation: location
        });
        return false;
      });
    }
    trackPromise(
      dataService.queries.getPlatformSingleServiceData(this.state.serviceId).then(
        (dataserviceapps) => {
          this.setState({
            apps: dataserviceapps,
            kubeHealthCheckClass: activePlatformDataObj.PlatformHealthCheckClass,
            healthCheckMessage: activePlatformDataObj.PlatformHealthCheckClass === "running" ? "Connected" : "Not connected, check the platform section for more info"
          })
        }
      )
    )
  }

  componentWillUnmount() {
    if (this.unblockHistory) {
      this.unblockHistory();
      this.unblockHistory = null;
    }
  }

  handleAppDirtyStateChange = (appId, appName, hasPendingChanges) => {
    if (hasPendingChanges) {
      this.setState(prevState => {
        if (!prevState.lockedAppId) {
          return { lockedAppId: appId, lockedAppName: appName };
        }
        if (String(prevState.lockedAppId) === String(appId)) return null;
        return null;
      });
      return;
    }

    this.setState(prevState => {
      if (prevState.lockedAppId && String(prevState.lockedAppId) === String(appId)) {
        return { lockedAppId: null, lockedAppName: "" };
      }
      return null;
    });
  }

  handleBlockedInteraction = (targetAppId, targetAppName) => {
    if (!this.state.lockedAppId || String(this.state.lockedAppId) === String(targetAppId)) return;
    this.setState({
      blockEditModalOpen: true,
      blockedTargetAppName: targetAppName
    });
  }

  closeBlockEditModal = () => {
    this.setState({ blockEditModalOpen: false, blockedTargetAppName: "" });
  }

  stayOnPage = () => {
    this.setState({ leavePageModalOpen: false, pendingNavLocation: null });
  }

  leaveWithoutSaving = () => {
    const nextLocation = this.state.pendingNavLocation;
    if (this.unblockHistory) {
      this.unblockHistory();
      this.unblockHistory = null;
    }
    this.setState(
      { lockedAppId: null, lockedAppName: "", leavePageModalOpen: false, pendingNavLocation: null },
      () => {
        if (nextLocation && this.props.history) {
          this.props.history.push(nextLocation.pathname + (nextLocation.search || "") + (nextLocation.hash || ""));
        }
      }
    );
  }

  render() {
    const t = this.props.i18n.t;
    let apps = this.state.apps;
    return (
      <>
        <div className="content">
          <Row>
            <Col md="12">
              <section className="section-wrapper">
                <h1 className="section-title">
                  <i className={this.state.serviceImage} />
                  <span className="context-root">{this.state.serviceName}</span>|
                  <span
                    id={"PlatformStatus-" + this.state.serviceId}
                    className={"status-icon " + this.state.kubeHealthCheckClass}>
                    <UncontrolledTooltip
                      placement="right"
                      target={"PlatformStatus-" + this.state.serviceId}
                    > {this.state.healthCheckMessage} </UncontrolledTooltip>
                  </span>
                  <span className="context-info">{this.props.kubernetesPlatformName}</span>
                  {platformStateTag(this.state.kubernetesState, this.state.kubernetesStateLevel)}
                </h1>
              </section>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <CardTitle tag="h4">{t("platformService.title")}</CardTitle>
                </CardHeader>
                <CardBody>
                  <Table id="Table" className="tablesorter" responsive>
                    <thead className="text-primary service-apps">
                      <tr className="theader">
                        <th className="row-1 row-statusaction">{t("platformService.action")}</th>
                        <th className="row-2 row-appname">{t("kubernetesPlatform.tableCreation.name")}</th>
                        <th className="row-3 row-services">{t("platformService.applications")}</th>
                        <th className="row-4 row-management">{t("kubernetesPlatform.tableCreation.management")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {apps.map((app, key) => {
                        return (
                          <>
                            <ServiceApp
                              t={t}
                              key={key}
                              app={app}
                              hexColor={this.props.hexColor}
                              lockedAppId={this.state.lockedAppId}
                              onBlockedInteraction={this.handleBlockedInteraction}
                              onAppDirtyStateChange={this.handleAppDirtyStateChange}
                            />
                          </>
                        )
                      })}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
        {this.state.blockEditModalOpen && (
          <GenericModal
            name="blockEditModal"
            toggleModal={this.closeBlockEditModal}
            acceptOnClick={this.closeBlockEditModal}
            modalTitleText={t("platformService.pendingChanges.blockOtherApp.title")}
            modalBodyText={t("platformService.pendingChanges.blockOtherApp.body", { appName: this.state.lockedAppName })}
            modalAcceptBtn={t("platformService.pendingChanges.blockOtherApp.ok")}
            modalCancelBtn=""
          />
        )}
        {this.state.leavePageModalOpen && (
          <GenericModal
            name="leavePageModal"
            toggleModal={this.stayOnPage}
            acceptOnClick={this.leaveWithoutSaving}
            cancelOnClick={this.stayOnPage}
            modalTitleText={t("platformService.pendingChanges.leavePage.title")}
            modalBodyText={t("platformService.pendingChanges.leavePage.body", { appName: this.state.lockedAppName })}
            modalAcceptBtn={t("platformService.pendingChanges.leavePage.leave")}
            modalCancelBtn={t("platformService.pendingChanges.leavePage.stay")}
          />
        )}
      </>
    )
  }
};
export default withRouter(PlatformService)
